import { StatTile } from '@/components/ui/stat-tile';
import { translate } from '../../../../utils/Common';

// paquetes en boxits vencidos por retirar
const PackagesExpired = ({ cantPackagesExpired, cardTitle, tooltipMessage }) => (
    <StatTile
        loading={!(cantPackagesExpired || cantPackagesExpired === 0)}
        value={cantPackagesExpired}
        label={cardTitle || translate("global.packages_expired.title")}
        info={
            tooltipMessage ||
            translate("dashboard.home.packages_expired.info_1") +
            translate("dashboard.home.packages_expired.info_2") +
            translate("dashboard.home.packages_expired.info_3")
        }
    />
);

export default PackagesExpired;
